export default __webpack_public_path__ + "static/media/assignment.5eafd140.svg";